import { GridInput } from '@it2go/data-grid';
import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../modules/content/service/gql.service-v2';
import { mpsvTargetGroupFrag } from '../types/mpsv-target-group.types';
import { filterFrag } from '../types/filter.types';
import { MpsvTargetGroupGridObject } from '@libs/types/src/list/object-type/mpsv-target-group.object';

@Injectable({ providedIn: 'root' })
export class ListMpsvTargetGroupService extends GqlServiceV2 {

    public getListMpsvTargetGroups(input: GridInput, frag = mpsvTargetGroupFrag) {
        return this.query<MpsvTargetGroupGridObject>(
            `
                query($input: GridInput!) {
                    mpsvTargetGroup {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

}
